import { render } from "./ItemMobile.vue?vue&type=template&id=5ba969af&scoped=true"
import script from "./ItemMobile.vue?vue&type=script&lang=js"
export * from "./ItemMobile.vue?vue&type=script&lang=js"

import "./ItemMobile.vue?vue&type=style&index=0&id=5ba969af&scoped=true&lang=css"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba969af"]])

export default __exports__